<template>
  <tr class="word">
    <td>
      <div v-if="word.ja">
        <span class="word__ja">{{ word.ja }}</span>
        <TextSpeak :text="word.ja" lang="ja" />
      </div>
      <span v-if="word.ja_kana" class="word__ja-kana block">{{ word.ja_kana }}</span>

      <img v-if="word.image_attached" :src="word.image" :alt="word.en" class="word__image" />
    </td>

    <td class="space-y-1">
      <div v-if="word.en">
        <router-link :to="{ path: `/tu-vung/${categorySlug}/${word.ja || word.en}` }" class="hover:underline">
          <span class="word__en">{{ word.en }}</span>
        </router-link>
        <TextSpeak :text="word.en" lang="en" />
      </div>

      <div v-if="word.vi">
        <span class="word__vi">{{ word.vi }}</span>
      </div>
    </td>

    <td class="word__description">
      <div v-if="word.description_admin || word.description_vi" class="text-sm w-12">
        <div class="link" @click="$emit('view-detail', word.id)">Chi tiết</div>
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
  import TextSpeak from '&/TextSpeak.vue'

  defineProps<{
    categorySlug: string
    word: object
  }>()
</script>
